import { createContext, useEffect, memo } from "react";
import QuestionFlow from "./QuestionFlow";
import HeaderClientAdmin from "../../components/HeaderClientAdmin/HeaderClientAdmin";
import Topbar from "../../components/Topbar";
import EditNodes from "../../components/EditNodes";
import "./styles.css";
import WorkbenchProviders from "../../context/workbench/WorkbenchProviders";
import WorkbenchLeftSidebar from "./WorkbenchLeftSidebar";

export const DnDContext = createContext({});
export const ContexValue = createContext({});

const Workbench = () => {

    // useEffect(() => {
    //     // clear secret_key from session while workbench unmounting phase
    //     return () => {
    //         sessionStorage.removeItem("secret_key");
    //         sessionStorage.removeItem("flow_type");
    //     };
    // }, []);

    return (
        <WorkbenchProviders>
            <div className="workbench-container">
                <div className="workbench-header">
                    <HeaderClientAdmin pageTitle="Workbench" config={{showModalTitle: true}}/>
                </div>
                <div className="workbench-content">
                    <Topbar />
                    <div className="workbench-main">
                        <WorkbenchLeftSidebar />
                        <div className="workbench-right-sidebar">
                            <EditNodes />
                            <QuestionFlow />
                        </div>
                    </div>
                </div>
            </div>
        </WorkbenchProviders>
    );
};

export default memo(Workbench);
